import BaseService from "./_base.service";
import { History } from "../models/history";

const endpoint = "job/histories";

const JobHistoryService = {
  ...BaseService<History>({ endpoint }),
};

export default JobHistoryService;
